"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file mlt_tileset_metadata.proto (package mlt, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComplexField = exports.ScalarField = exports.Field = exports.ComplexColumn = exports.ScalarColumn = exports.Column = exports.FeatureTableSchema = exports.TileSetMetadata = exports.LogicalComplexType = exports.LogicalScalarType = exports.ComplexType = exports.ScalarType = exports.ColumnScope = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from enum mlt.ColumnScope
 */
var ColumnScope;
(function (ColumnScope) {
    /**
     * 1:1 Mapping of property and feature -> id and geometry
     *
     * @generated from enum value: FEATURE = 0;
     */
    ColumnScope[ColumnScope["FEATURE"] = 0] = "FEATURE";
    /**
     * For M-Values -> 1:1 Mapping for property and vertex
     *
     * @generated from enum value: VERTEX = 1;
     */
    ColumnScope[ColumnScope["VERTEX"] = 1] = "VERTEX";
})(ColumnScope || (exports.ColumnScope = ColumnScope = {}));
// Retrieve enum metadata with: proto3.getEnumType(ColumnScope)
protobuf_1.proto3.util.setEnumType(ColumnScope, "mlt.ColumnScope", [
    { no: 0, name: "FEATURE" },
    { no: 1, name: "VERTEX" },
]);
/**
 * @generated from enum mlt.ScalarType
 */
var ScalarType;
(function (ScalarType) {
    /**
     * @generated from enum value: BOOLEAN = 0;
     */
    ScalarType[ScalarType["BOOLEAN"] = 0] = "BOOLEAN";
    /**
     * @generated from enum value: INT_8 = 1;
     */
    ScalarType[ScalarType["INT_8"] = 1] = "INT_8";
    /**
     * @generated from enum value: UINT_8 = 2;
     */
    ScalarType[ScalarType["UINT_8"] = 2] = "UINT_8";
    /**
     * @generated from enum value: INT_32 = 3;
     */
    ScalarType[ScalarType["INT_32"] = 3] = "INT_32";
    /**
     * @generated from enum value: UINT_32 = 4;
     */
    ScalarType[ScalarType["UINT_32"] = 4] = "UINT_32";
    /**
     * @generated from enum value: INT_64 = 5;
     */
    ScalarType[ScalarType["INT_64"] = 5] = "INT_64";
    /**
     * @generated from enum value: UINT_64 = 6;
     */
    ScalarType[ScalarType["UINT_64"] = 6] = "UINT_64";
    /**
     * @generated from enum value: FLOAT = 7;
     */
    ScalarType[ScalarType["FLOAT"] = 7] = "FLOAT";
    /**
     * @generated from enum value: DOUBLE = 8;
     */
    ScalarType[ScalarType["DOUBLE"] = 8] = "DOUBLE";
    /**
     * @generated from enum value: STRING = 9;
     */
    ScalarType[ScalarType["STRING"] = 9] = "STRING";
})(ScalarType || (exports.ScalarType = ScalarType = {}));
// Retrieve enum metadata with: proto3.getEnumType(ScalarType)
protobuf_1.proto3.util.setEnumType(ScalarType, "mlt.ScalarType", [
    { no: 0, name: "BOOLEAN" },
    { no: 1, name: "INT_8" },
    { no: 2, name: "UINT_8" },
    { no: 3, name: "INT_32" },
    { no: 4, name: "UINT_32" },
    { no: 5, name: "INT_64" },
    { no: 6, name: "UINT_64" },
    { no: 7, name: "FLOAT" },
    { no: 8, name: "DOUBLE" },
    { no: 9, name: "STRING" },
]);
/**
 * @generated from enum mlt.ComplexType
 */
var ComplexType;
(function (ComplexType) {
    /**
     * fixed size binary with 2 values of the same type either signed or unsigned Int8, Int32, Int64 as well as Float or Double
     *
     * @generated from enum value: VEC_2 = 0;
     */
    ComplexType[ComplexType["VEC_2"] = 0] = "VEC_2";
    /**
     * fixed size binary with 2 values of the same type either signed or unsigned Int8, Int32, Int64 as well as Float or Double
     *
     * @generated from enum value: VEC_3 = 1;
     */
    ComplexType[ComplexType["VEC_3"] = 1] = "VEC_3";
    /**
     * vec2<Int32> for the VertexBuffer stream with additional information (streams) about the topology
     *
     * @generated from enum value: GEOMETRY = 2;
     */
    ComplexType[ComplexType["GEOMETRY"] = 2] = "GEOMETRY";
    /**
     * vec3<Int32> for the VertexBuffer stream with additional information (streams) about the topology
     *
     * @generated from enum value: GEOMETRY_Z = 3;
     */
    ComplexType[ComplexType["GEOMETRY_Z"] = 3] = "GEOMETRY_Z";
    /**
     * @generated from enum value: LIST = 4;
     */
    ComplexType[ComplexType["LIST"] = 4] = "LIST";
    /**
     * @generated from enum value: MAP = 5;
     */
    ComplexType[ComplexType["MAP"] = 5] = "MAP";
    /**
     * @generated from enum value: STRUCT = 6;
     */
    ComplexType[ComplexType["STRUCT"] = 6] = "STRUCT";
})(ComplexType || (exports.ComplexType = ComplexType = {}));
// Retrieve enum metadata with: proto3.getEnumType(ComplexType)
protobuf_1.proto3.util.setEnumType(ComplexType, "mlt.ComplexType", [
    { no: 0, name: "VEC_2" },
    { no: 1, name: "VEC_3" },
    { no: 2, name: "GEOMETRY" },
    { no: 3, name: "GEOMETRY_Z" },
    { no: 4, name: "LIST" },
    { no: 5, name: "MAP" },
    { no: 6, name: "STRUCT" },
]);
/**
 * @generated from enum mlt.LogicalScalarType
 */
var LogicalScalarType;
(function (LogicalScalarType) {
    /**
     * physical type: Int64 -> number of milliseconds since Unix epoch
     *
     * @generated from enum value: TIMESTAMP = 0;
     */
    LogicalScalarType[LogicalScalarType["TIMESTAMP"] = 0] = "TIMESTAMP";
    /**
     * physical type: Int32 -> number of days since Unix epoch
     *
     * @generated from enum value: DATE = 1;
     */
    LogicalScalarType[LogicalScalarType["DATE"] = 1] = "DATE";
    /**
     * physical type: String
     *
     * @generated from enum value: JSON = 2;
     */
    LogicalScalarType[LogicalScalarType["JSON"] = 2] = "JSON";
})(LogicalScalarType || (exports.LogicalScalarType = LogicalScalarType = {}));
// Retrieve enum metadata with: proto3.getEnumType(LogicalScalarType)
protobuf_1.proto3.util.setEnumType(LogicalScalarType, "mlt.LogicalScalarType", [
    { no: 0, name: "TIMESTAMP" },
    { no: 1, name: "DATE" },
    { no: 2, name: "JSON" },
]);
/**
 * @generated from enum mlt.LogicalComplexType
 */
var LogicalComplexType;
(function (LogicalComplexType) {
    /**
     * physical type: list<UInt8>
     *
     * @generated from enum value: BINARY = 0;
     */
    LogicalComplexType[LogicalComplexType["BINARY"] = 0] = "BINARY";
    /**
     * physical type: map<vec2<double, T>> -> special data structure which can be used for a efficient representation of linear referencing
     *
     * @generated from enum value: RANGE_MAP = 1;
     */
    LogicalComplexType[LogicalComplexType["RANGE_MAP"] = 1] = "RANGE_MAP";
})(LogicalComplexType || (exports.LogicalComplexType = LogicalComplexType = {}));
// Retrieve enum metadata with: proto3.getEnumType(LogicalComplexType)
protobuf_1.proto3.util.setEnumType(LogicalComplexType, "mlt.LogicalComplexType", [
    { no: 0, name: "BINARY" },
    { no: 1, name: "RANGE_MAP" },
]);
/**
 * @generated from message mlt.TileSetMetadata
 */
class TileSetMetadata extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: int32 version = 1;
         */
        this.version = 0;
        /**
         * @generated from field: repeated mlt.FeatureTableSchema featureTables = 2;
         */
        this.featureTables = [];
        /**
         * order left, bottom, right, top in WGS84
         *
         * @generated from field: repeated double bounds = 8;
         */
        this.bounds = [];
        /**
         * order longitude, latitude in WGS84
         *
         * @generated from field: repeated double center = 9;
         */
        this.center = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new TileSetMetadata().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TileSetMetadata().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TileSetMetadata().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(TileSetMetadata, a, b);
    }
}
exports.TileSetMetadata = TileSetMetadata;
TileSetMetadata.runtime = protobuf_1.proto3;
TileSetMetadata.typeName = "mlt.TileSetMetadata";
TileSetMetadata.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "featureTables", kind: "message", T: FeatureTableSchema, repeated: true },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "attribution", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 6, name: "minZoom", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 7, name: "maxZoom", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 8, name: "bounds", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, repeated: true },
    { no: 9, name: "center", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, repeated: true },
]);
/**
 * @generated from message mlt.FeatureTableSchema
 */
class FeatureTableSchema extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string name = 1;
         */
        this.name = "";
        /**
         * @generated from field: repeated mlt.Column columns = 2;
         */
        this.columns = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new FeatureTableSchema().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FeatureTableSchema().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FeatureTableSchema().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(FeatureTableSchema, a, b);
    }
}
exports.FeatureTableSchema = FeatureTableSchema;
FeatureTableSchema.runtime = protobuf_1.proto3;
FeatureTableSchema.typeName = "mlt.FeatureTableSchema";
FeatureTableSchema.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "columns", kind: "message", T: Column, repeated: true },
]);
/**
 * Column are top-level types in the schema
 *
 * @generated from message mlt.Column
 */
class Column extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string name = 1;
         */
        this.name = "";
        /**
         * specifies if the values are optional in the column and a present stream should be used
         *
         * @generated from field: bool nullable = 2;
         */
        this.nullable = false;
        /**
         * @generated from field: mlt.ColumnScope columnScope = 3;
         */
        this.columnScope = ColumnScope.FEATURE;
        /**
         * @generated from oneof mlt.Column.type
         */
        this.type = { case: undefined };
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new Column().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Column().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Column().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(Column, a, b);
    }
}
exports.Column = Column;
Column.runtime = protobuf_1.proto3;
Column.typeName = "mlt.Column";
Column.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "nullable", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "columnScope", kind: "enum", T: protobuf_1.proto3.getEnumType(ColumnScope) },
    { no: 4, name: "scalarType", kind: "message", T: ScalarColumn, oneof: "type" },
    { no: 5, name: "complexType", kind: "message", T: ComplexColumn, oneof: "type" },
]);
/**
 * @generated from message mlt.ScalarColumn
 */
class ScalarColumn extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from oneof mlt.ScalarColumn.type
         */
        this.type = { case: undefined };
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new ScalarColumn().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ScalarColumn().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ScalarColumn().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(ScalarColumn, a, b);
    }
}
exports.ScalarColumn = ScalarColumn;
ScalarColumn.runtime = protobuf_1.proto3;
ScalarColumn.typeName = "mlt.ScalarColumn";
ScalarColumn.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 4, name: "physicalType", kind: "enum", T: protobuf_1.proto3.getEnumType(ScalarType), oneof: "type" },
    { no: 5, name: "logicalType", kind: "enum", T: protobuf_1.proto3.getEnumType(LogicalScalarType), oneof: "type" },
]);
/**
 * The type tree is flattened in to a list via a pre-order traversal
 * Represents a column if it is a root (top-level) type or a child of a nested type
 *
 * @generated from message mlt.ComplexColumn
 */
class ComplexColumn extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from oneof mlt.ComplexColumn.type
         */
        this.type = { case: undefined };
        /**
         * The complex type Geometry and the logical type BINARY have no children since there layout is implicit known.
         * RangeMap has only one child specifying the type of the value since the key is always a vec2<double>.
         *
         * @generated from field: repeated mlt.Field children = 6;
         */
        this.children = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new ComplexColumn().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ComplexColumn().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ComplexColumn().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(ComplexColumn, a, b);
    }
}
exports.ComplexColumn = ComplexColumn;
ComplexColumn.runtime = protobuf_1.proto3;
ComplexColumn.typeName = "mlt.ComplexColumn";
ComplexColumn.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 4, name: "physicalType", kind: "enum", T: protobuf_1.proto3.getEnumType(ComplexType), oneof: "type" },
    { no: 5, name: "logicalType", kind: "enum", T: protobuf_1.proto3.getEnumType(LogicalComplexType), oneof: "type" },
    { no: 6, name: "children", kind: "message", T: Field, repeated: true },
]);
/**
 * Fields define nested or leaf types in the schema as part of a complex type definition
 *
 * @generated from message mlt.Field
 */
class Field extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from oneof mlt.Field.type
         */
        this.type = { case: undefined };
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new Field().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Field().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Field().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(Field, a, b);
    }
}
exports.Field = Field;
Field.runtime = protobuf_1.proto3;
Field.typeName = "mlt.Field";
Field.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 2, name: "nullable", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 3, name: "scalarField", kind: "message", T: ScalarField, oneof: "type" },
    { no: 4, name: "complexField", kind: "message", T: ComplexField, oneof: "type" },
]);
/**
 * @generated from message mlt.ScalarField
 */
class ScalarField extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from oneof mlt.ScalarField.type
         */
        this.type = { case: undefined };
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new ScalarField().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ScalarField().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ScalarField().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(ScalarField, a, b);
    }
}
exports.ScalarField = ScalarField;
ScalarField.runtime = protobuf_1.proto3;
ScalarField.typeName = "mlt.ScalarField";
ScalarField.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "physicalType", kind: "enum", T: protobuf_1.proto3.getEnumType(ScalarType), oneof: "type" },
    { no: 2, name: "logicalType", kind: "enum", T: protobuf_1.proto3.getEnumType(LogicalScalarType), oneof: "type" },
]);
/**
 * @generated from message mlt.ComplexField
 */
class ComplexField extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from oneof mlt.ComplexField.type
         */
        this.type = { case: undefined };
        /**
         * @generated from field: repeated mlt.Field children = 3;
         */
        this.children = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new ComplexField().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ComplexField().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ComplexField().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(ComplexField, a, b);
    }
}
exports.ComplexField = ComplexField;
ComplexField.runtime = protobuf_1.proto3;
ComplexField.typeName = "mlt.ComplexField";
ComplexField.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "physicalType", kind: "enum", T: protobuf_1.proto3.getEnumType(ComplexType), oneof: "type" },
    { no: 2, name: "logicalType", kind: "enum", T: protobuf_1.proto3.getEnumType(LogicalComplexType), oneof: "type" },
    { no: 3, name: "children", kind: "message", T: Field, repeated: true },
]);
//# sourceMappingURL=mlt_tileset_metadata_pb.js.map